import { defineMessages } from 'react-intl'

// NOTE: scope id intentionally kept as 'globalSearch.GlobalSearchModal' to
// preserve existing translations after the GlobalSearchModal → GlobalSearchView
// rename. Update only with a coordinated localization migration.
const scope = 'procurify.platform.globalSearch.GlobalSearchModal'

export default defineMessages({
  enterToSearchHint: {
    id: `${scope}.enterToSearchHint`,
    defaultMessage: '⏎ Enter to search',
  },
})
